export type VoucherValidationResponse = {
  valid: boolean;
  reason?: string;
  message?: string;
};

export type VoucherRedemptionResponse = {
  success: boolean;
  message?: string;
  error?: string;
  voucher?: {
    id: string;
    isUsed: boolean;
    usedBy: string;
    usedAt: string;
  };
};

export type VoucherStatusResponse = {
  hasRedeemedVoucher: boolean;
};

/**
 * Validate a voucher code
 */
export const validateVoucher = async (code: string, userToken: string): Promise<VoucherValidationResponse> => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/vouchers/validate`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${userToken}`,
      },
      body: JSON.stringify({ code }),
    });
    
    const data = await response.json();
    
    if (!response.ok) {
      return { valid: false, reason: data.error || 'Validation failed' };
    }
    
    return data;
  } catch (error) {
    return { valid: false, reason: 'Network error occurred' };
  }
};

/**
 * Redeem a voucher code
 */
export const redeemVoucher = async (code: string, userToken: string): Promise<VoucherRedemptionResponse> => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/vouchers/redeem`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${userToken}`,
      },
      body: JSON.stringify({ code }),
    });
    
    const data = await response.json();
    
    if (!response.ok) {
      return { success: false, error: data.error || 'Redemption failed' };
    }
    
    return data;
  } catch (error) {
    return { success: false, error: 'Network error occurred' };
  }
};

/**
 * Check voucher redemption status for current user
 */
export const getVoucherStatus = async (userToken: string): Promise<VoucherStatusResponse> => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/vouchers/status`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${userToken}`,
    },
  });
  
  if (!response.ok) {
    throw new Error('Failed to get voucher status');
  }
  
  return response.json();
};